import { useId } from "react";
import { cardStyles } from "../../../../core/Card.styles.js";
import { FeatureCard } from "../../../../core/FeatureCard.js";
import { Section } from "../../../../patterns/Section.js";
import { SectionHeader } from "../../../../patterns/SectionHeader.js";
import type { PromisesContent } from "../../homeContent.js";

/** The store's promises (shipping, condition), with art beside them on wide screens. */
export function HomePromises(promises: PromisesContent) {
  const id = useId();
  if (promises.items.length === 0) return null;
  return (
    <Section aria-labelledby={id} className="flex flex-col gap-6">
      <SectionHeader title={promises.title} titleId={id} subtitle={promises.subtitle} />
      <div className="grid gap-3 md:gap-5 lg:grid-cols-[2fr_1fr]">
        <ul className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-5">
          {promises.items.map((item) => (
            <li key={item.title}>
              <FeatureCard {...item} className="h-full" />
            </li>
          ))}
        </ul>
        {promises.media && (
          <div
            className={cardStyles({
              radius: "2xl",
              className: "relative overflow-hidden max-lg:hidden",
            })}
          >
            {promises.media}
          </div>
        )}
      </div>
    </Section>
  );
}
